var map = {
	"./Group 5915.svg": "./src/assets/image/icones/notifications/Group 5915.svg",
	"./HoursCorrection.svg": "./src/assets/image/icones/notifications/HoursCorrection.svg",
	"./Vector(2).svg": "./src/assets/image/icones/notifications/Vector(2).svg",
	"./btnCloseRed.svg": "./src/assets/image/icones/notifications/btnCloseRed.svg",
	"./cloche.svg": "./src/assets/image/icones/notifications/cloche.svg",
	"./clock.svg": "./src/assets/image/icones/notifications/clock.svg",
	"./fileManager.svg": "./src/assets/image/icones/notifications/fileManager.svg",
	"./groupes.svg": "./src/assets/image/icones/notifications/groupes.svg",
	"./horaire.svg": "./src/assets/image/icones/notifications/horaire.svg",
	"./newCandidate.svg": "./src/assets/image/icones/notifications/newCandidate.svg",
	"./news.svg": "./src/assets/image/icones/notifications/news.svg",
	"./point_rouge.svg": "./src/assets/image/icones/notifications/point_rouge.svg",
	"./taskCanceled.svg": "./src/assets/image/icones/notifications/taskCanceled.svg",
	"./taskInprogress.svg": "./src/assets/image/icones/notifications/taskInprogress.svg",
	"./taskPerformed.svg": "./src/assets/image/icones/notifications/taskPerformed.svg",
	"./taskTodo.svg": "./src/assets/image/icones/notifications/taskTodo.svg",
	"./users.svg": "./src/assets/image/icones/notifications/users.svg",
	"./warning.svg": "./src/assets/image/icones/notifications/warning.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image/icones/notifications sync recursive ^\\.\\/.*$";